import * as CONST from '../ActionTypes';

const initialState = {
  wholesalePrices: {},
  wholesalePrice: {},
  wholesaleCompanies: {},
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
};

function wholesalePrice(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 卸売り価格の一覧取得
    // -----------------
    case CONST.GET_WHOLESALE_PRICE_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          wholesalePrices: action.payload,
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.GET_WHOLESALE_PRICE_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          wholesalePrices: {},
          isSuccess: false,
          isFailure: false,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 卸売り価格の詳細取得
    // -----------------
    case CONST.GET_WHOLESALE_PRICE_DETAILS_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          wholesalePrice: action.payload,
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.GET_WHOLESALE_PRICE_DETAILS_FAILURE:
      return Object.assign(
        {},
        state,
        {
          wholesalePrice: {},
          isSuccess: false,
          isFailure: false,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 卸売り価格の追加
    // -----------------
    case CONST.CREATE_WHOLESALE_PRICE_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.CREATE_WHOLESALE_PRICE_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 卸売り価格の追加
    // -----------------
    case CONST.UPDATE_WHOLESALE_PRICE_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.UPDATE_WHOLESALE_PRICE_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    case CONST.CLEAR_WHOLESALE_PRICE_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: action.payload,
        },
      );
      // -----------------
    // 卸売り価格の一覧取得
    // -----------------
    case CONST.GET_WHOLESALE_COMPANY_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          wholesaleCompanies: action.payload,
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.GET_WHOLESALE_COMPANY_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          wholesaleCompanies: {},
          isSuccess: false,
          isFailure: false,
          errorMessage: action.payload,
        },
      );
      // -----------------
    // 卸売り価格の追加
    // -----------------
    case CONST.CREATE_WHOLESALE_COMPANY_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.CREATE_WHOLESALE_COMPANY_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    default:
      return state;
  }
}

export default wholesalePrice;
